export default __webpack_public_path__ + "static/media/lady-bw.178ec362.jpg";